<template>
  <div class="sc-nav">
    <nav class="a-slider-nav a-slider-nav--slider">
      <button
        class="a-slider-nav__btn a-slider-nav__btn--prev btn"
        :disabled="prevDisabled"
        @click="() => click('prev')"
      >
        <Icon icon="chevron-left" title="Previous scorecard" />
      </button>
      <button
        class="a-slider-nav__btn a-slider-nav__btn--next btn"
        :disabled="nextDisabled"
        @click="() => click('next')"
      >
        <Icon icon="chevron-right" title="Next scorecard" />
      </button>
    </nav>
    <ScoreLegend />
  </div>
</template>

<script>
import { Icon } from "@international-energy-agency/vue-ui";
import ScoreLegend from "./ScoreLegend.vue";
export default {
  name: "ScorecardNav",
  components: {
    Icon,
    ScoreLegend,
  },
  props: {
    slidesLength: {
      required: false,
      default: 10,
    },
    selectedIndex: {
      required: false,
    },
    responsive: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    prevDisabled() {
      const { responsive, selectedIndex} = this;
      return !responsive && selectedIndex === 0;
    },
    nextDisabled() {
      const { responsive, selectedIndex, slidesLength} = this;
      return !responsive && selectedIndex === (slidesLength - 1);
    },
  },
  methods: {
    click(dir) {
      this.$emit("click", dir);
    },
  },
};
</script>

<style>
.sc-nav {
  margin-left: calc(322px + 32px);
}
.a-slider-nav__btn:disabled {
  color: #949494;
  cursor: default;
  opacity: 1;
}
@media screen and (max-width: 959px) {
  .sc-nav {
    margin-left: 0;
  }
}
</style>
